"use client";
import React from "react";
import {FontIcon} from "@/app/_components";
import {GetUserLatestOrdersResponse} from "@/app/_api/types/store";
import {PayStatus} from "@/app/(pay)/types";
import styles from './paymentList.module.css';
import Util from "@/Master/Util";
import {confJson} from "@/app/config/confJson";

type PaymentListProps = {
    dataSource: GetUserLatestOrdersResponse;
}

const PayList: React.FC<PaymentListProps> = (props) => {
    const { dataSource } = props;

    return (
        <section className={styles.wrapper}>
            <section className={styles.head}>
                <section className={`${styles.col}`}>Amount</section>
                <section className={`${styles.col}`}>Purchasing</section>
                <section className={`${styles.col}`}>Bendfits</section>
                <section className={`${styles.col}`}>Time</section>
                <section className={`${styles.col}`}>Result</section>
            </section>

            {dataSource.map(item => {
                return <section className={styles.row} key={item.id}>
                    <section className={`${styles.col}`}>
                        <img className={styles.icon_payment} src={confJson.game_api_url + item.atr_icon} alt=""/>
                        <div>${item.payAmount}</div>
                    </section>
                    <section className={`${styles.col}`}>
                        <img className={styles.icon_coin} src="/img/ico_sc.png" alt=""/>
                        <div>{item?.itemsContent?.sc}</div>
                    </section>
                    <section className={`${styles.col}`}>
                        <img className={styles.icon_coin} src="/img/ico_gc.png" alt=""/>
                        <div>{item?.itemsContent?.gc}</div>
                    </section>
                    <section className={`${styles.col}`}>{Util.timeStampToLocale(item.createTime)}</section>

                    {item.orderStatus === PayStatus.WAITING && <section className={`${styles.col} ${styles.waiting}`}>
                        <FontIcon icon="s-wait" style={{fontSize: '.5rem'}}/>
                        <div>Waiting</div>
                    </section>}

                    {item.orderStatus === PayStatus.CREATE_FAIL && <section className={`${styles.col} ${styles.waiting}`}>
                        <FontIcon icon="s-wait" style={{fontSize: '.5rem'}}/>
                        <div>Create Fail</div>
                    </section>}

                    {item.orderStatus === PayStatus.SUCCESS && <section className={`${styles.col} ${styles.sucess}`}>
                        <FontIcon icon="s-success" style={{fontSize: '.5rem'}}/>
                        <div>Successful</div>
                    </section>}

                    {item.orderStatus === PayStatus.FAIL && <section className={`${styles.col} ${styles.fail}`}>
                        <FontIcon icon="s-fail" style={{fontSize: '.5rem'}}/>
                        <div>Fail</div>
                    </section>}

                    {item.orderStatus === PayStatus.CANCEL && <section className={`${styles.col} ${styles.fail}`}>
                        <FontIcon icon="s-fail" style={{fontSize: '.5rem'}}/>
                        <div>Cancel</div>
                    </section>}

                    {item.orderStatus === PayStatus.TIMEOUT && <section className={`${styles.col} ${styles.fail}`}>
                        <FontIcon icon="s-fail" style={{fontSize: '.5rem'}}/>
                        <div>Timeout</div>
                    </section>}
                </section>
            })}
        </section>
    )
}

export default PayList;